/** Default tab when map/to-do are unavailable (event has no maps). Tries data, inventory, users, properties; otherwise data. */
export function getDefaultEventTabWhenNoMap(perms: {
    canViewWasteData: boolean;
    canViewInventory: boolean;
    canEditUsers: boolean;
    canEditEvents: boolean;
}): string {
    if (perms.canViewWasteData) return 'data';
    if (perms.canViewInventory) return 'inventory';
    if (perms.canEditUsers) return 'eventUsers';
    if (perms.canEditEvents) return 'settings';
    return 'data';
}
